export const EditSvg = ({ color, widthSize, heightSize }) => {
    const defaultFill = "#ED5E2A"; // Default color if 'color' prop is not provided
    const fillColour = color || defaultFill;



    return (
        <svg width={widthSize || "17"} height={heightSize || "20"} viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.59961 18H15.5996C15.8648 18 16.1192 18.1054 16.3067 18.2929C16.4943 18.4804 16.5996 18.7348 16.5996 19C16.5996 19.2652 16.4943 19.5196 16.3067 19.7071C16.1192 19.8946 15.8648 20 15.5996 20H1.59961C1.33439 20 1.08004 19.8946 0.892503 19.7071C0.704966 19.5196 0.599609 19.2652 0.599609 19C0.599609 18.7348 0.704966 18.4804 0.892503 18.2929C1.08004 18.1054 1.33439 18 1.59961 18ZM0.599609 13L10.5996 3L13.5996 6L3.59961 16H0.599609V13ZM11.5996 2L13.5996 0L16.5996 3L14.5986 5.001L11.5996 2Z"
                fill={fillColour} // Use the determined fill color
            />
        </svg>
    );
};
